import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { generateInvoice } from "../../services/invoiceService";
import {
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Container,
  Box,
  Grid,
} from "@mui/material";
import toast from "react-hot-toast";

import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';


const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const InvoiceGenerator = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customer } = location.state || {}; // Get customer from navigation state
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Default to current month
  const [invoiceUrl, setInvoiceUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleGenerateInvoice = async () => {
    if (!customer?.id) {
      toast.error("No customer data found. Please select a valid customer.");
      return;
    }
    setLoading(true);
    try {
      const response = await generateInvoice(customer.id, selectedMonth);

      if (response.success) {
        setInvoiceUrl(response.url);
        toast.success(
          `Invoice for ${months[selectedMonth - 1]} generated successfully!`
        );
      } else {
        setInvoiceUrl(null); // ✅ Clear previous invoice details
        toast.error("Invoice generation failed. Please try again.");
      }
    } catch (err) {
      setInvoiceUrl(null); // ✅ Clear previous invoice details on error
      toast.error(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  console.log("customer", customer);

  // const handleDownloadInvoice = async () => {
  //   try {
  //     const response = await fetch(invoiceUrl);
  //     const blob = await response.blob();
  //     const file = new Blob([blob], { type: "application/pdf" });

  //     // Create a temporary download link
  //     const fileURL = URL.createObjectURL(file);
  //     const a = document.createElement("a");
  //     a.href = fileURL;
  //     a.download = `Invoice-${customer.name}-${months[selectedMonth - 1]}.pdf`;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);

  //     toast.success("Invoice downloaded successfully!");
  //     return fileURL; // Return the file URL for sharing
  //   } catch (error) {
  //     toast.error("Failed to download invoice. Try again.");
  //     return null;
  //   }
  // };

  const handleDownloadInvoice = async () => {
  if (!invoiceUrl) return null;
  try {
    const response = await fetch(invoiceUrl);
    const blob = await response.blob();
    // Convert blob to base64
    const convertBlobToBase64 = (blob) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => resolve(reader.result.split(',')[1]); // Remove data:*/*;base64,
        reader.readAsDataURL(blob);
      });
    };
    const base64Data = await convertBlobToBase64(blob);
    // Write file to Documents directory
    const fileName = `Invoice-${customer.name}-${months[selectedMonth - 1]}.pdf`;
    await Filesystem.writeFile({
      path: fileName,
      data: base64Data,
      directory: Directory.Documents,
    });
    toast.success("Invoice downloaded successfully!");
    return fileName; // return filename for sharing
  } catch (error) {
    console.error(error);
    toast.error("Failed to download invoice.");
    return null;
  }
};

// const handleDownloadInvoice = async () => {
//   if (!invoiceUrl) return null;
//   try {
//     const response = await fetch(invoiceUrl);
//     const blob = await response.blob();

//     const fileName = `Invoice-${customer.name}-${months[selectedMonth - 1]}.pdf`;

//     // Check if running in a browser (window is defined)
//     if (typeof window !== "undefined" && window.document) {
//       // Browser download logic
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = fileName;
//       document.body.appendChild(a);
//       a.click();
//       setTimeout(() => {
//         window.URL.revokeObjectURL(url);
//         document.body.removeChild(a);
//       }, 100);
//       toast.success("Invoice downloaded successfully!");
//       return fileName;
//     } else {
//       // Mobile/Filesystem logic
//       // Convert blob to base64
//       const convertBlobToBase64 = (blob) => {
//         return new Promise((resolve, reject) => {
//           const reader = new FileReader();
//           reader.onerror = reject;
//           reader.onload = () => resolve(reader.result.split(',')[1]); // Remove data:*/*;base64,
//           reader.readAsDataURL(blob);
//         });
//       };
//       const base64Data = await convertBlobToBase64(blob);
//       await Filesystem.writeFile({
//         path: fileName,
//         data: base64Data,
//         directory: Directory.Documents,
//       });
//       toast.success("Invoice downloaded successfully!");
//       return fileName;
//     }
//   } catch (error) {
//     console.error(error);
//     toast.error("Failed to download invoice.");
//     return null;
//   }
// };

const handleShareOnWhatsApp = async () => {
  const filename = await handleDownloadInvoice();
  if (!filename) return;

  try {
    const { uri } = await Filesystem.getUri({
      path: filename,
      directory: Directory.Documents,
    });

    await Share.share({
      title: 'Share Invoice',
      text: `Hello ${customer.name}, here is your invoice for ${months[selectedMonth - 1]}.`,
      url: uri,
      dialogTitle: 'Share Invoice via',
    });

    toast.success("Sharing via WhatsApp or other apps started.");
  } catch (err) {
    console.error("Sharing error", err);
    toast.error("Sharing failed.");
  }
};

  // const handleShareOnWhatsApp = async () => {
  //   const fileURL = await handleDownloadInvoice();
  //   if (!fileURL) return;

  //   // Create WhatsApp message
  //   const whatsappMessage = `Hello ${customer.name}, your invoice for ${
  //     months[selectedMonth - 1]
  //   } is ready. I'm sharing the PDF file with you.`;

  //   // Open WhatsApp with a pre-filled message
  //   const whatsappURL = `https://wa.me/91${
  //     customer.mobile
  //   }?text=${encodeURIComponent(whatsappMessage)}`;
  //   window.open(whatsappURL, "_blank");

  //   toast.success("WhatsApp opened. Attach the invoice manually.");
  // };

  return (
    <Container maxWidth="sm" sx={{ py: 2 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <FaArrowLeft
          onClick={() => navigate(-1)} // Go back to the previous page
          style={{ cursor: "pointer", marginRight: "8px" }}
        />
        <Typography variant="h6">Invoice: {customer.name}</Typography>
      </Box>

      {/* Customer Details */}
      {customer ? (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              {/* Left Side: Customer Details */}
              <Grid item xs={6}>
                <Typography variant="h6">Customer</Typography>
                <Typography>
                  <strong>Name:</strong> {customer.name}
                </Typography>
                <Typography>
                  <strong>Mobile:</strong> {customer.mobile}
                </Typography>
                <Typography>
                  <strong>Address:</strong> {customer.address}
                </Typography>
              </Grid>

              {/* Right Side: Bottles Balance */}
              <Grid item xs={6}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    backgroundColor: "#f3f4f6",
                    padding: 2,
                    borderRadius: "8px",
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Balance:
                  </Typography>
                  <Typography sx={{ color: "blue" }}>
                    Cool: {customer.cool_container_balance || 0}
                  </Typography>
                  <Typography sx={{ color: "blue" }}>
                    Pet : {customer.pet_container_balance || 0}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ) : (
        <Typography color="error">No customer selected.</Typography>
      )}

      {/* Month Selection */}
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ display: "flex", gap: 2, flexDirection: "column" }}>
          <FormControl fullWidth>
            <InputLabel>Select Month</InputLabel>
            <Select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              label="Select Month"
            >
              {months.map((month, index) => (
                <MenuItem key={index + 1} value={index + 1}>
                  {month}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            color="primary"
            onClick={handleGenerateInvoice}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Generate Invoice"
            )}
          </Button>
        </CardContent>
      </Card>

      {/* Display generated invoice details */}
      {invoiceUrl && (
        <Card
          sx={{
            mt: 3,
            p: 3,
            textAlign: "center",
            boxShadow: 3,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Invoice Ready for {months[selectedMonth - 1]} 🎉
          </Typography>

          <Typography variant="body1" sx={{ mb: 1 }}>
            Click below to download your invoice.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            // href={invoiceUrl}
            onClick={handleDownloadInvoice}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              width: "100%",
              py: 1.5,
              fontSize: "1rem",
              fontWeight: "bold",
              mt: 2,
            }}
          >
            📄 Download Invoice
          </Button>

          {/* Share on WhatsApp Button */}
          <Button
            variant="contained"
            color="success"
            onClick={handleShareOnWhatsApp}
            sx={{
              width: "100%",
              py: 1.5,
              fontSize: "1rem",
              fontWeight: "bold",
              mt: 2,
            }}
          >
            📲 Share on WhatsApp
          </Button>
        </Card>
      )}
    </Container>
  );
};

export default InvoiceGenerator;
